import React from "react";

// The green verified rosette (founder, 1.5.2): a true circle of 12 equal lobes
// in Brand Green with a dark tick — the same drawing as the talent's Edit
// profile (.verified-badge). Fans see it only on their own screens (the
// "Instagram connected" card, My Profile): everywhere else the Instagram mark
// itself says the handle is theirs. Sized by the text around it (1em).
export const VerifiedTick: React.FC<{ className?: string; label: string }> = ({ className, label }) => (
  <svg
    className={`verified-tick${className ? ` ${className}` : ""}`}
    width="1em"
    height="1em"
    viewBox="-1 -1 26 26"
    role="img"
    aria-label={label}
  >
    <path
      fill="#24C961"
      stroke="#24C961"
      strokeWidth="1.8"
      strokeLinejoin="round"
      d="M12 1.5L14.38 3.11L17.25 2.91L18.51 5.49L21.09 6.75L20.89 9.62L22.5 12L20.89 14.38L21.09 17.25L18.51 18.51L17.25 21.09L14.38 20.89L12 22.5L9.62 20.89L6.75 21.09L5.49 18.51L2.91 17.25L3.11 14.38L1.5 12L3.11 9.62L2.91 6.75L5.49 5.49L6.75 2.91L9.62 3.11Z"
    />
    <path fill="none" stroke="#0a0d14" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M8 11.9l2.7 2.7L16 9.3" />
  </svg>
);

// The same tick as a promise, beside a row that does not have it yet (founder,
// 2026-11-02). Hidden from screen readers: it must never read out "Verified".
export const VerifiedTickTease: React.FC = () => (
  <span className="verified-tick-tease" aria-hidden="true">
    <VerifiedTick label="" />
  </span>
);

export default VerifiedTick;
